module.exports = __webpack_public_path__ + "img/20210730_213301.95f8d84b.jpg";